<script>
export default {
  template: '<template></template>',
}
</script>

<style lang="scss">
@use './CookiePolicy';
</style>
